module.exports = __webpack_public_path__ + "img/On_Location_Shoot.2bfb6a1c.gif";